import React from 'react'

import { Box, Divider, Paper, Typography } from '@material-ui/core'

import { Dai } from 'components'

import useDaiChat from 'hooks/useDaiChat'

import daiLogo from 'images/dai-star-logo-blue.png'
import useStyles from './styles'

const ChatPanel = () => {
  const classes = useStyles()
  // Nome vem pelo DaiChatContext — o fluxo guest não tem AuthContext, então
  // ChatPanel não pode depender de useAuth (compartilhado entre os dois fluxos).
  const { hasMessage, userName } = useDaiChat()

  const greetingName = userName || 'Usuário'

  return (
    <Paper variant="outlined" className={classes.panel}>
      <Box className={classes.header}>
        <Box className={classes.daiBadge}>
          <img src={daiLogo} alt="DAI" className={classes.daiLogo} />
          <Typography variant="caption" className={classes.preview}>
            PREVIEW
          </Typography>
        </Box>
      </Box>

      <Divider />

      <Box className={classes.messages}>
        {!hasMessage && (
          <Box className={classes.greeting}>
            <Typography variant="h3" className={classes.greetingTitle}>
              Olá {greetingName} 👋,
            </Typography>
            <Typography variant="h5" className={classes.greetingSubtitle}>
              Sou a DAI, inteligência artificial especializada em LGPD.
            </Typography>
            <Typography variant="h3" className={classes.greetingTitle}>
              Estou aqui para te ajudar com seu cadastro de inventário de IA.
            </Typography>
          </Box>
        )}
        <Dai.ChatMessages className={classes.daiMessages} />
      </Box>

      <Box className={classes.footer}>
        <Dai.ChatActions
          minRows={2}
          placeholder="Conte para a DAI como a IA é usada na empresa..."
        />
      </Box>
    </Paper>
  )
}

export default ChatPanel
